import { render, staticRenderFns } from "./NetworkItem.vue?vue&type=template&id=af143736&scoped=true&"
import script from "./NetworkItem.vue?vue&type=script&lang=js&"
export * from "./NetworkItem.vue?vue&type=script&lang=js&"
import style0 from "./NetworkItem.vue?vue&type=style&index=0&id=af143736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af143736",
  null
  
)

export default component.exports